/* What this organisation has, held once for the whole app.
 *
 * The menu, the screens and the New button all need the same answer, and
 * asking per component would mean a page load hitting licensing nine times
 * and nine chances to disagree with itself.
 */
import { createContext, useContext } from 'react'
import type { ModuleState } from '@jackdesk/erp-kit'

export const ModulesContext = createContext<ModuleState | null>(null)

export const useModules = () => useContext(ModulesContext)

/** Which DocType modules this org may open at all. */
export function readableModules(state: ModuleState | null): Set<string> | null {
  if (!state) return null                 // not known yet: show everything
  const out = new Set(state.always)
  for (const area of state.areas) {
    // Lapsed is still readable. That is the whole point.
    if (area.state !== 'off') area.modules.forEach((m) => out.add(m))
  }
  return out
}

/** May this org still change things here? */
export function canWriteIn(state: ModuleState | null, module?: string): boolean {
  if (!state || !module) return true
  if (state.always.includes(module)) return true
  const area = state.areas.find((a) => a.modules.includes(module))
  return area ? area.can_write : true
}

/** The area a DocType module belongs to, for saying what to buy. */
export function areaFor(state: ModuleState | null, module?: string) {
  if (!state || !module) return null
  return state.areas.find((a) => a.modules.includes(module)) ?? null
}
